export interface PredefinedTech {
  name: string;
  category: string;
}

export const PREDEFINED_TECH_STACK: Record<string, PredefinedTech[]> = {
  Frontend: [
    { name: 'React', category: 'Frontend' },
    { name: 'Vue', category: 'Frontend' },
    { name: 'Angular', category: 'Frontend' },
    { name: 'TypeScript', category: 'Frontend' },
    { name: 'Next.js', category: 'Frontend' },
    { name: 'Svelte', category: 'Frontend' },
    { name: 'HTML/CSS', category: 'Frontend' },
    { name: 'Tailwind CSS', category: 'Frontend' },
    { name: 'Material-UI', category: 'Frontend' },
  ],
  Backend: [
    { name: 'Node.js', category: 'Backend' },
    { name: 'Python', category: 'Backend' },
    { name: 'Java', category: 'Backend' },
    { name: 'C#/.NET', category: 'Backend' },
    { name: 'Go', category: 'Backend' },
    { name: 'Rust', category: 'Backend' },
    { name: 'Ruby', category: 'Backend' },
    { name: 'PHP', category: 'Backend' },
    { name: 'Scala', category: 'Backend' },
    { name: 'Kotlin', category: 'Backend' },
  ],
  Database: [
    { name: 'PostgreSQL', category: 'Database' },
    { name: 'MySQL', category: 'Database' },
    { name: 'MongoDB', category: 'Database' },
    { name: 'Redis', category: 'Database' },
    { name: 'Snowflake', category: 'Database' },
    { name: 'BigQuery', category: 'Database' },
    { name: 'Cassandra', category: 'Database' },
    { name: 'DynamoDB', category: 'Database' },
    { name: 'Elasticsearch', category: 'Database' },
    { name: 'Firebase', category: 'Database' },
  ],
  Cloud: [
    { name: 'AWS', category: 'Cloud' },
    { name: 'Google Cloud', category: 'Cloud' },
    { name: 'Microsoft Azure', category: 'Cloud' },
    { name: 'AWS Lambda', category: 'Cloud' },
    { name: 'AWS S3', category: 'Cloud' },
    { name: 'AWS RDS', category: 'Cloud' },
    { name: 'Google Cloud Storage', category: 'Cloud' },
    { name: 'Azure Cosmos DB', category: 'Cloud' },
  ],
  DevOps: [
    { name: 'Docker', category: 'DevOps' },
    { name: 'Kubernetes', category: 'DevOps' },
    { name: 'Terraform', category: 'DevOps' },
    { name: 'Ansible', category: 'DevOps' },
    { name: 'Jenkins', category: 'DevOps' },
    { name: 'GitLab CI', category: 'DevOps' },
    { name: 'GitHub Actions', category: 'DevOps' },
    { name: 'Prometheus', category: 'DevOps' },
    { name: 'Grafana', category: 'DevOps' },
  ],
  'Data & Analytics': [
    { name: 'Apache Spark', category: 'Data & Analytics' },
    { name: 'Apache Airflow', category: 'Data & Analytics' },
    { name: 'Apache Kafka', category: 'Data & Analytics' },
    { name: 'Tableau', category: 'Data & Analytics' },
    { name: 'Looker', category: 'Data & Analytics' },
    { name: 'dbt', category: 'Data & Analytics' },
    { name: 'Apache Flink', category: 'Data & Analytics' },
    { name: 'Databricks', category: 'Data & Analytics' },
  ],
  Mobile: [
    { name: 'React Native', category: 'Mobile' },
    { name: 'Flutter', category: 'Mobile' },
    { name: 'Swift', category: 'Mobile' },
    { name: 'Kotlin', category: 'Mobile' },
    { name: 'Xamarin', category: 'Mobile' },
  ],
  Other: [
    { name: 'Git', category: 'Other' },
    { name: 'GraphQL', category: 'Other' },
    { name: 'REST API', category: 'Other' },
    { name: 'WebSocket', category: 'Other' },
  ],
};

export const TECH_CATEGORIES = Object.keys(PREDEFINED_TECH_STACK);
